import { LitElement, html, css } from 'lit'
import 'bui/elements/headers'
import 'bui/elements/hr'
import docs from 'bui/README.md'
//import './setup'
import './changelog'

let docsStr = docs
let trimIndex = docsStr.search('## 🎉 Features')
docsStr = trimIndex > -1 ? docsStr.substr(trimIndex) : docsStr

// FIXME: needs improvement
var matches;
while (matches = /\(\.\/(.[^\/]+)\/README\.md\)/.exec(docsStr)) {
    docsStr = docsStr.replace(matches[0], `(/${matches[1]})`)
}

window.docsStr = docsStr

customElements.define('demo-overview', class extends LitElement{

    static get properties() {
        return {
            dark: { type: Boolean, reflect: true }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        const isDark = document.documentElement.hasAttribute('dark');
        this.dark = isDark;

        const observer = new MutationObserver(() => {
            this.dark = document.documentElement.hasAttribute('dark');
        });
        observer.observe(document.documentElement, { attributes: true });
    }

    static get title(){ return 'Home' }
    static get icon() { return 'home' }
    static get path(){ return 'home(/:view(/*))' }

    static get styles(){return css`
        :host {
            display: grid;
            position:relative;
            height: 100%;
            overflow: hidden;
        }

        .hide-in-dark {
            display: block;
        }
        :host([dark]) .hide-in-dark {
            display: none;
        }

        :host(:not([dark])) .hide-in-light {
            display: none;
        }


        .bgd {
            left: 0;
            height: 60vh;
            top: -7%;
            position: absolute;
            //background: linear-gradient(-20deg, #222, #111);
            //opacity: .8;
            width: 100%;
            transform: skewY(4deg);
            z-index: 0;
        }

        .bgd.color {
            opacity: 1;
            background: var(--theme);
        }

        .bgd.old {
            display: none;
            background: linear-gradient(-20deg, #1b3b52, #2c3033);
        }

        main {
            margin: 1em auto;
            /* width: 900px;
            max-width: calc(100% - var(--view-gutter)); */
            max-width: 900px;
            position: relative;
            z-index: 1;
        }

        header {
            color: white;
            --theme-text: white;
            text-align: center;
            font-size: 1.4em;
            /* padding-top: var(--view-gutter); */
            padding-bottom: 3%;
        }

        @media (max-width: 599px) {
            header {
                font-size: 1em;
            }

            .bgd {
                height: 70vh;
            }
        }

        bui-logo {
            --size: 5em;
            color: #fff;
            margin-bottom: 1rem;
        }

        main > b-paper {
            min-height: 50vh;
            padding: var(--view-gutter);
        }

        header [xl] {
            filter: drop-shadow(0 0 2rem black);
        }

        @media (min-width: 600px) {
            header [xl] {
                font-size: 1.6em;
            }
        }

        a, a:visited {
            color: var(--theme);
            text-decoration: none;
        }

        b-tabs > * {
            min-width: 0;
        }

        b-tabs-router::part(tab-bar) {
            background-color: var(--theme-bgd);/
            /* color: white; */
            /* --inactiveColor: rgba(255,255,255,.4); */
            /* --border-color: rgba(255,255,255,.1); */
        }
    `}

    render(){return html`
        <div class="bgd old"></div>

        <div class="bgd color"></div>
        <div class="bgd"></div>
        

        <b-tabs-router path="home/" key="demo-overview">
            <div title="Info" view-id="about">
            <main>

                <header>

                    <bui-logo></bui-logo>
                    
                    <b-text xl align="center" block xbold>
                        <b-text>Digitaler</b-text> 
                        <b-text xbold>Lieferschein</b-text>
                    </b-text>

                    <b-text body>Speditionen - Lieferanten - Kunden - Nachunternehmer</b-text>

                </header>

                <b-paper overshadow>

                    <demo-markdown-docs notoc .docs=${docsStr}></demo-markdown-docs>
                   

                    <p align="center">
                        <img class="hide-in-dark" src="data:image/png;base64,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" /> 
                    </p>

                    
                    <p align="center">
                        <img class="hide-in-light" src="data:image/png;base64,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" />
                    </p>


                    
               
          
</b-paper>

            </main>
            </div>

      
            demo-changelog         

        </b-tabs-router>
    `}

    //render() {
    //    return html`
    //    <div class="bgd old"></div>

    //    <div class="bgd color"></div>
    //    <div class="bgd"></div>
        

    //    <b-tabs-router path="overview/" key="demo-overview">
    //        <div title="Aboutxx" view-id="about">
    //        <main>

    //            <header>

    //                <bui-logo></bui-logo>
                    
    //                <b-text xxl align="center" block xbold>
    //                    <b-text gradient>Blackstone</b-text> 
    //                    <b-text xbold>UI</b-text>
    //                </b-text>

    //                <b-text body><a href="https://developer.mozilla.org/en-US/docs/Web/Web_Components">Web components</a>, classes, and utilities for creating single-page PWAs. Built with <a href="https://lit.dev">Lit</a> by Blackstone Publishing</b-text>

    //            </header>

    //            <b-paper overshadow>

    //                <demo-markdown-docs notoc .docs=${docsStr}></demo-markdown-docs>

    //            </b-paper>

    //        </main>
    //        </div>

    //        demo-setup
    //        demo-changelog

    //    </b-tabs-router>
    //`}

})

export default customElements.get('demo-overview')

const codePreview = `
<b-paper compact>
<b-tabs>
    <div title="Tab 1">
        <b-spinner-overlay></b-spinner-overlay>
        <header>
            <h3>
                <b-icon name="folder"></b-icon> 
                Title
                <b-label>Active</b-label>
            </h3>
            <b-uploader url="/" auto-upload></b-uploader>
            <b-btn icon="upload-cloud" class="text-btn" onclick="this.previousElementSibling.selectFile()">Upload</b-btn>
        </header>
        <main>
            Content here
            <b-hr></b-hr>
            More content
        </main>
    </div>
    <div title="Tab 2">
        Tab 2 content
    </div>
</b-tabs>
</b-paper>`